"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import { PaymentMethod } from '@l2p/pay-api'
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = __importStar(require("react"));
var PaymentsFields_1 = __importDefault(require("./PaymentsFields"));
var SideBar_1 = require("./SideBar");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Payments = function (_a) {
    var type = _a.type, methods = _a.methods, _b = _a.isModal, isModal = _b === void 0 ? false : _b, paymentSettings = _a.paymentSettings, accountTypes = _a.accountTypes;
    var balanceData = (0, swr_hooks_1.useBalance)().data;
    var _c = (0, react_1.useState)(false), mounted = _c[0], setMounted = _c[1];
    var _d = (0, react_1.useState)(null), selectedMethod = _d[0], setSelectedMethod = _d[1];
    (0, react_1.useEffect)(function () {
        setMounted(true);
        return function () { return setMounted(false); };
    }, []);
    var setMethodSelected = (0, react_1.useCallback)(function (method) {
        setSelectedMethod(method);
    }, []);
    if (!methods || !mounted)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(SideBar_1.SideBar, { selectedMethod: selectedMethod, setMethodSelected: setMethodSelected, methods: methods, balanceAmount: balanceData === null || balanceData === void 0 ? void 0 : balanceData.totalAmount, currency: balanceData === null || balanceData === void 0 ? void 0 : balanceData.currency, isModal: isModal, type: type, paymentSettings: paymentSettings }),
        react_1.default.createElement(PaymentsFields_1.default, { selectedMethod: selectedMethod, type: type, currency: balanceData === null || balanceData === void 0 ? void 0 : balanceData.currency, isModal: isModal, accountTypes: accountTypes, paymentSettings: paymentSettings })));
};
exports.default = Payments;
